export default __webpack_public_path__ + "static/media/bg.a53818e6.svg";